import React from 'react';
import { toast } from 'sonner';
import { useLanguage } from '../../i18n';

const Step2_Project = ({ 
  formData, 
  onInputChange,
  onBack, 
  onNext 
}) => {
  const { t } = useLanguage();

  const handleNext = () => {
    if (formData.building_type === 'sonstiges' && !formData.building_type_other?.trim()) {
      toast.error(t('buildingTypeOtherError'));
      return;
    }
    onNext();
  };

  return (
    <div className="step-content" data-testid="step-2">
      <h2 className="step-title">{t('step2Title')}</h2>
      <p className="step-description">{t('step2Desc')}</p>
      <div className="form-group">
        <label className="form-label">{t('projectTypeLabel')}</label>
        <div className="radio-group">
          <div className="radio-option">
            <input type="radio" name="project_type" value="neubau" checked={formData.project_type === 'neubau'} onChange={onInputChange} id="neubau" data-testid="project-neubau" />
            <label htmlFor="neubau" className="radio-label">{t('projectNeubau')}</label>
          </div>
          <div className="radio-option">
            <input type="radio" name="project_type" value="tausch" checked={formData.project_type === 'tausch'} onChange={onInputChange} id="tausch" data-testid="project-tausch" />
            <label htmlFor="tausch" className="radio-label">{t('projectTausch')}</label>
          </div>
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">{t('buildingTypeLabel')}</label>
        <div className="radio-group">
          <div className="radio-option">
            <input type="radio" name="building_type" value="efh" checked={formData.building_type === 'efh'} onChange={onInputChange} id="efh" data-testid="building-efh" />
            <label htmlFor="efh" className="radio-label">{t('buildingEfh')}</label>
          </div>
          <div className="radio-option">
            <input type="radio" name="building_type" value="mfh" checked={formData.building_type === 'mfh'} onChange={onInputChange} id="mfh" data-testid="building-mfh" />
            <label htmlFor="mfh" className="radio-label">{t('buildingMfh')}</label>
          </div>
          <div className="radio-option">
            <input type="radio" name="building_type" value="sonstiges" checked={formData.building_type === 'sonstiges'} onChange={onInputChange} id="sonstiges" data-testid="building-sonstiges" />
            <label htmlFor="sonstiges" className="radio-label">{t('buildingSonstig')}</label>
          </div>
        </div>
        {formData.building_type === 'sonstiges' && (
          <div className="form-group" style={{ marginTop: '1rem' }}>
            <label className="form-label">{t('buildingTypeOtherLabel')}</label>
            <input type="text" name="building_type_other" value={formData.building_type_other} onChange={onInputChange} className="form-input" placeholder={t('buildingTypeOtherPlaceholder')} maxLength={128} data-testid="building-type-other-input" />
            <p style={{ fontSize: '0.75rem', color: '#666', marginTop: '0.25rem' }}>
              {formData.building_type_other.length}/128 {t('buildingTypeOtherCount')}
            </p>
          </div>
        )}
      </div>
      <div className="button-group">
        <button onClick={onBack} className="btn-secondary" data-testid="step-2-back-btn">{t('back')}</button>
        <button onClick={handleNext} className="btn-primary" data-testid="step-2-next-btn">{t('next')}</button>
      </div>
    </div>
  );
};

export default Step2_Project;
